import { Avatar, Card } from "antd";
import { BubbleIcon, CardWrapper } from "./styled";
import { FC } from "react";
import { getRandomColor } from "./utils";
import { FeedbackSource } from "../../../../types/matchday";

const icon = (
    <svg width="9" height="20" viewBox="0 0 9 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill="#ffffff" d="M8,1 L9,1 L9,20 L8,20 L8,18 C7.807,15.161 7.124,12.233 5.950,9.218 C5.046,6.893 3.504,4.733 1.325,2.738 L1.325,2.738 C0.917,2.365 0.89,1.732 1.263,1.325 C1.452,1.118 1.72,1 2,1 L8,1 Z" />
        <path d="M7.99983 1H8.99983V20H7.99983V18C7.80683 15.161 7.12383 12.233 5.94983 9.218C5.04583 6.893 3.50383 4.733 1.32483 2.738C0.916825 2.365 0.889825 1.732 1.26283 1.325C1.45183 1.118 1.71983 1 1.99983 1H7.99983Z" fill="white" />
        <path d="M8.99995 1H1.99995C1.71995 1 1.45195 1.118 1.26295 1.325C0.889946 1.732 0.916946 2.365 1.32495 2.738C3.50395 4.733 5.04595 6.893 5.94995 9.218C7.12395 12.233 7.80695 15.161 7.99995 18V20H8.99995V1ZM1.99995 0H8.99995V20H6.99995L7.00195 18.068C6.81595 15.333 6.15595 12.504 5.01795 9.58C4.17195 7.406 2.71995 5.371 0.648946 3.475C-0.165054 2.729 -0.221054 1.464 0.524946 0.649C0.903946 0.236 1.43895 0 1.99995 0Z" fill="#D7E3EC" />
    </svg>
);

const doveIcon = (
    <svg width="24" height="28" viewBox="0 0 410 484" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M137.606 377.433C140.259 377.04 142.815 376.548 145.469 375.958C142.618 375.172 140.063 375.369 137.606 376.45C117.063 378.612 96.7171 381.757 76.666 385.787C89.4437 376.155 102.516 366.916 115.982 358.266C134.854 347.061 153.922 336.053 172.99 325.339C171.319 325.143 169.648 325.339 168.075 325.831C152.841 331.531 137.409 336.741 121.879 341.557C118.636 342.245 115.294 342.245 112.05 341.557C88.8539 336.249 66.5422 328.583 45.2133 318.459C49.4397 312.955 55.0423 308.138 61.9225 304.207C63.102 303.519 63.102 303.027 61.9225 302.732C52.7816 306.369 43.5424 309.908 34.4014 313.544C22.5084 306.467 11.0085 298.604 0 289.955C26.2434 266.464 55.1406 246.707 86.495 230.489C98.4863 224.002 111.264 221.643 124.828 223.609C149.499 235.797 172.499 250.737 193.631 268.331C193.926 268.036 194.319 267.643 194.614 267.348C184.785 243.857 172.99 221.447 159.229 200.02C171.909 187.34 184.686 174.563 197.562 161.687C185.768 163.554 173.973 166.011 162.178 169.058C159.229 110.773 174.464 58.0892 207.883 10.8119C210.832 7.07686 213.977 3.44014 217.22 0C224.002 15.8247 233.34 29.8801 245.233 42.2646C258.305 55.3371 271.476 68.508 284.549 81.5805C291.724 90.3283 297.621 99.7641 302.241 110.085C304.01 127.777 304.01 145.469 302.241 163.161C299.292 190.78 295.656 218.302 291.429 245.724C311.284 228.819 333.399 215.549 357.775 205.917C366.031 204.934 373.894 206.212 381.364 209.849C386.279 213.78 390.8 218.007 395.125 222.626C399.941 226.263 404.856 229.703 409.868 232.947C398.27 237.566 388.245 244.447 379.89 253.588C370.061 272.951 359.839 292.314 349.42 311.579C331.63 337.822 307.155 354.629 276.194 362.198C268.134 364.164 259.878 365.441 251.622 366.129C249.361 366.424 247.494 367.604 246.216 369.569C239.827 380.676 234.323 392.078 229.507 403.971C219.678 430.018 210.34 456.261 201.494 482.603C192.353 483.782 183.212 483.88 173.973 483.094C138.392 479.457 103.696 471.889 69.7857 460.488C82.5634 449.676 95.3411 438.864 108.119 428.052C107.824 427.855 107.431 427.757 107.136 427.56C90.6232 435.62 74.6019 444.466 58.9739 454.099C48.9483 447.513 40.7902 439.159 34.4014 429.035C53.273 409.77 75.5848 396.009 101.238 387.753C113.132 383.723 125.319 380.283 137.606 377.433Z" fill="#FDFDFD" />
    </svg>
);

interface FeedbackItemProps {
    imageUrl?: string;
    title?: string;
    text: string;
    linkUrl?: string;
    date?: string;
    source?: FeedbackSource;
}

export const FeedbackItem: FC<FeedbackItemProps> = ({
    imageUrl,
    title,
    text,
    linkUrl,
    date,
    source,
}) => {
    let coverImage = null;
    if (imageUrl) {
        coverImage = <img src={imageUrl} alt="Фон"></img>
    }

    const classNames = "relative max-w-[500px] max-w-full sm:w-[400px] sm:min-w-[350px] flex flex-row" + (!linkUrl ? "" : " cursor-pointer");

    const cardTitle = (
        <div>
            <span className="!text-sky-950">{title || "Болельщик ФК «Родина»"}</span>
        </div>
    )

    return (
        <CardWrapper onClick={() => linkUrl && globalThis.open(linkUrl, '_blank')} className={classNames}>
            {!imageUrl && <BubbleIcon>{icon}</BubbleIcon>}
            <div className="hidden sm:block">
                <Avatar
                    size={36}
                    icon={!title ? doveIcon : null}
                    style={{ marginRight: 10, backgroundColor: getRandomColor() }}
                >
                    {title?.[0]?.toUpperCase()}
                </Avatar>
            </div>
            <Card style={{ maxWidth: 350, borderTopLeftRadius: 0, width: 350 }} cover={coverImage} styles={{ body: { paddingLeft: 18, paddingRight: 18, paddingTop: 16, paddingBottom: 16 } }}>
                <Card.Meta
                    title={cardTitle}
                    description={(
                        <div>
                            <div className="text-sky-950 text-base">{text}</div>
                            <div className="flex flex-row justify-between pt-2">
                                <div>
                                    {source === FeedbackSource.APP && (
                                        <a href="https://my.fcrodina.com" className="text-sky-700">
                                            в приложении «Родные»
                                        </a>
                                    )}
                                </div>
                                <div className="!text-slate-400">
                                    {date}
                                </div>
                            </div>
                        </div>
                    )}
                    style={{
                        color: 'black'
                    }}
                />
            </Card>
        </CardWrapper>
    );
};